<rt-select2
  #select
  [formControl]="control()"
  [rtProtectedControl]="control()"
  [searchControl]="searchControl"
  [items]="selectOptions()"
  [disabled]="isReadOnly()"
  alwaysOpen
  withSearch
  withMultiselect
>
  <rt-select-trigger-multi
    [isInvalid]="isInvalid()"
    [placeholder]="'app.common.select' | translate"
    [disabled]="isReadOnly()"
    [extendedPreviewInOverlay]="false"
  />
  <ng-template
    [rtSelectSelectedItem]="select"
    let-remove="remove"
    let-item="item"
    let-showRemoveIcon="showRemoveIcon"
  >
    <rt-chips
      [text]="item.label"
      [showClose]="showRemoveIcon"
      (close)="remove(item)"
      class="chips-item"
    >
      @if (item?.imageUrl) {
        <rt-avatar type="image" size="small-x" [imageSrc]="item.imageUrl!" prefix />
      }
    </rt-chips>
  </ng-template>
  <ng-template
    rtSelectSelectedItemCounter
    let-hiddenCount="hiddenCount"
    let-hiddenItems="hiddenItems"
  >
    <rt-chips
      [text]="'+' + hiddenCount"
      [showClose]="false"
      [tooltip]="getTooltipLabel(hiddenItems)"
      (click)="isReadOnly() && $event.preventDefault()"
      class="chips-item"
    />
  </ng-template>
  <ng-template
    [rtSelectListItem]="select"
    let-selectCtrl
    let-item="item"
    let-isHoverState="isHoverState"
  >
    <rt-dropdown-item (click)="selectCtrl.select$.next(item)" [class.hover]="isHoverState">
      <rt-checkbox
        prefix
        [checked]="selectCtrl.itemSelector.isSelected(item)"
        [hasMargin]="false"
        (valueChange)="selectCtrl.select$.next(item)"
      />

      <div layout-vertical>
        <div layout layout-align-items-center>
          @if (item?.imageUrl) {
            <rt-avatar
              type="image"
              size="small-x"
              [imageSrc]="item.imageUrl!"
              margin-right-small-xx
              prefix
            />
          }
          {{ item.label }}
        </div>
        @if ($safeNavigationMigration(item?.membersCount) !== undefined) {
          <div class="team-members" text-weight-default>
            {{
              'app.custom_fields.manage_custom_field_dialog.form.team_members'
                | translate: { count: item.membersCount }
            }}
          </div>
        }
      </div>
    </rt-dropdown-item>
  </ng-template>
</rt-select2>
